import busImage from '../../assets/img/item_service.png'
import { IServiceProps } from './components/item-service/item-service'
import climatizacion from '../../assets/img/climatizacion.png'
import gps from '../../assets/img/gps.png'
import banio from '../../assets/img/banio.png'
import comodidad from '../../assets/img/comodidad.png'
import multimedia from '../../assets/img/multimedia.png'

export const listServices: IServiceProps[] = [
    {
      image: busImage,
      preTitle: 'Servicio',
      title: 'Panorámico',
      to: '/servicios/detalle',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrs standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book',
      listOptions: [
        {
            id: 1,
            icon: climatizacion,
            name: 'Climatización'
        },
        {
            id: 2,
            icon: multimedia,
            name: 'Multimedia'
        },
        {
            id: 3,
            icon: gps,
            name: 'GPS 24h'
        },
        {
            id: 4,
            icon: comodidad,
            name: 'Comodidad'
        },
        {
            id: 5,
            icon: banio,
            name: 'Baño'
        },
      ]
    },
    {
      image: busImage,
      preTitle: 'Servicio',
      title: 'Bus Cama VIP',
      to: '/servicios/detalle',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrs standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book',
      listOptions: [
        {
            id: 1,
            icon: climatizacion,
            name: 'Climatización'
        },
        {
            id: 2,
            icon: multimedia,
            name: 'Multimedia'
        },
        {
            id: 3,
            icon: gps,
            name: 'GPS 24h'
        },
        {
            id: 4,
            icon: comodidad,
            name: 'Comodidad'
        },
        {
            id: 5,
            icon: banio,
            name: 'Baño'
        },
      ]
    },
    {
      image: busImage,
      preTitle: 'Servicio',
      title: 'Económico',
      to: '/servicios/detalle',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrs standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book',
      listOptions: [
        {
            id: 1,
            icon: climatizacion,
            name: 'Climatización'
        },
        {
            id: 2,
            icon: multimedia,
            name: 'Multimedia'
        },
        {
            id: 3,
            icon: gps,
            name: 'GPS 24h'
        },
        {
            id: 4,
            icon: comodidad,
            name: 'Comodidad'
        },
        {
            id: 5,
            icon: banio,
            name: 'Baño'
        },
      ]
    },
]